import React, {Component} from "react";
import {connect} from 'react-redux';
import {Collapse, Spin, Table} from "antd";
import {toLocaleString} from "../../../../UserService/Common/utils";
import styles from "./DataSetDetail.css";

const Panel = Collapse.Panel;

class DataSetDetail extends Component {

  render() {
    console.debug("DataSetDetail:", this.props.nodeId, this.props.selectId, this.props.selectType, this.props.dataSetMap[this.props.nodeId]);
    const datasetInfo = this.props.dataSetMap[this.props.nodeId];

    let columns = [{
      title: "name",
      dataIndex: "name",
      key: "name",
      width: 100,
    }, {
      title: "value",
      dataIndex: "value",
      key: "value"
    }];

    let data = [{
      key: "1",
      name: "名称",
      value: datasetInfo.name
    }, {
      key: "2",
      name: "类别",
      value: datasetInfo.category ? datasetInfo.category.name : "N/A"
    }, {
      key: "3",
      name: "创建时间",
      value: datasetInfo.createdAt ? toLocaleString(datasetInfo.createdAt, false) : "N/A"
    }, {
      key: "4",
      name: "文件路径",
      value: datasetInfo.path ? datasetInfo.path : "N/A",
    }, {
      key: "5",
      name: "文件大小",
      value: datasetInfo.size ? datasetInfo.size : "N/A"
    }, {
      key: "6",
      name: "所属项目",
      value: datasetInfo.projectFile ? datasetInfo.projectFile : "N/A"
    }, {
      key: "7",
      name: "用户",
      value: datasetInfo.userId ? datasetInfo.userId : "N/A"
    }, {
      key: "8",
      name: "是否系统",
      value: datasetInfo.system ? "是" : "否"
    }];

    return (
      <Spin spinning={datasetInfo === ""} size="large">
        <Collapse bordered={false} defaultActiveKey={['1']}>
          <Panel header="数据集基础信息" key="1">
            <div style={{
              display: "flex",
              // overflow: "scroll"
            }}>
              {/*<div>
                <div className="ds-detail-label">名称:</div>
                <div className="ds-detail-label">类别:</div>
                <div className="ds-detail-label">创建时间:</div>
                <div className="ds-detail-label">文件路径:</div>
                <div className="ds-detail-label">文件大小:</div>
                <div className="ds-detail-label">所属项目:</div>
                <div className="ds-detail-label">用户:</div>
                <div className="ds-detail-label">是否系统:</div>
              </div>
              <div style={{minWidth: 100}}>
                <div className="ds-detail-info">{datasetInfo.name}</div>
                <div className="ds-detail-info">{datasetInfo.category ? datasetInfo.category.name : "N/A"}</div>
                <div className="ds-detail-info">{datasetInfo.createdAt ? toLocaleString(datasetInfo.createdAt, false) : "N/A"}</div>
                <div className="ds-detail-info">{datasetInfo.path ? datasetInfo.path : "N/A"}</div>
                <div className="ds-detail-info">{datasetInfo.size ? datasetInfo.size : "N/A"}</div>
                <div className="ds-detail-info">{datasetInfo.projectFile ? datasetInfo.projectFile : "N/A"}</div>
                <div className="ds-detail-info">{datasetInfo.userId ? datasetInfo.userId : "N/A"}</div>
                <div className="ds-detail-info">{datasetInfo.system ? "是" : "否"}</div>
              </div>*/}
              <Table columns={columns} dataSource={data} showHeader={false} pagination={false}/>
            </div>
          </Panel>
          <Panel header="数据集简介" key="2">
            <div style={{paddingLeft: 16}}>{datasetInfo.description}</div>
          </Panel>
        </Collapse>
      </Spin>
    )
  }
}


export const mapStateToProps = (state) => {
  return {
    selectId: state.projectPanel.selectId,
    selectType: state.projectPanel.selectType,
    nodeId: state.projectPanel.nodeId
  }
};

export const mapDispatchToProps = (dispatch) => {
  return {
    dispatch
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(DataSetDetail);
